// Saneo de los valores que se interpolan en las plantillas ZPL de etiquetas.
//
// En ZPL II el `^` abre un comando y el `~` un comando de control, y el `^FD`
// termina en el siguiente `^`: cualquier dato del paquete que los contenga SALE
// del campo y se ejecuta como formato. Un comentario de pedido como
// "^FS^FO0,0^GB800,1200,1200^FS" pinta un rectángulo negro sobre la etiqueta
// completa, y en la descarga masiva —que concatena todos los paquetes en un
// solo archivo— también puede romper las etiquetas que van después, de otros
// comercios.
//
// Los campos impresos con `^FH` (Field Hexadecimal) admiten además la notación
// `_XX`, así que ahí el `_` es prefijo de escape y hay que duplicarlo (`_5F`) o
// el dato se corrompe. Qué placeholder vive dentro de un `^FH` es propiedad de
// la plantilla (src/config/newZebraTemplate.js), así que se declara acá y
// ningún llamador tiene que acordarse.

/** Placeholders cuyo `^FD` NO lleva `^FH`: el `_` es literal y no se escapa. */
const PLAIN_PLACEHOLDERS = new Set([
  "{{packageKey}}", // QR: ^BQN...^FD sin ^FH
  "{{order_id}}",   // ^FO40,750 sin ^FH
  "{{fecha}}",      // ^FO40,885 sin ^FH
]);

/** Valores que YA son ZPL o que llegan saneados de otro lado: pasan tal cual. */
const RAW_PLACEHOLDERS = new Set([
  "{{logoCliente}}",      // bloque ^GFA del logo, viene del backend (getLogo)
  "{{bultoLine}}",        // línea ^FO...^FD que arma el propio generador
  "{{exchangeLine}}",     // ídem: línea fija de cambio de producto (downloadZebra.js)
  "{{receiver.comment}}", // ya saneado y escapado en labelAdditionalInfo.js
]);

// \p{Cc} = categoría Unicode "control" (0x00-0x1F, 0x7F y los C1 0x80-0x9F).
// Clase Unicode en vez de un rango con escapes: sin bytes de control en el
// fuente y sin disparar no-control-regex.
const CONTROL_CHARS = /\p{Cc}/gu;
const ZPL_PREFIXES = /[\^~]/g;

/**
 * Quita los prefijos de comando ZPL y los caracteres de control. Se reemplazan
 * por espacio (no se borran) para no pegar dos palabras en la etiqueta.
 */
export const zplSafe = (value) => {
  if (value === null || value === undefined) return "";
  return String(value).replace(CONTROL_CHARS, " ").replace(ZPL_PREFIXES, " ");
};

/** Igual que `zplSafe`, para campos impresos con `^FH`: escapa el `_`. */
export const zplSafeHex = (value) => zplSafe(value).replace(/_/g, "_5F");

/**
 * Sustituye un placeholder de la plantilla por su valor ya saneado.
 *
 * El reemplazo va como FUNCIÓN a propósito: con un string, `replace` interpreta
 * `$&`, `` $` ``, `$'` y `$$`, así que un dato del paquete igual a `` $` ``
 * vuelca la plantilla anterior completa —con todos sus comandos ^— dentro del
 * campo. Con función replacer el valor se inserta literal.
 */
export const zplField = (zpl, placeholder, value) => {
  const rendered = RAW_PLACEHOLDERS.has(placeholder)
    ? String(value ?? "")
    : PLAIN_PLACEHOLDERS.has(placeholder)
      ? zplSafe(value)
      : zplSafeHex(value);
  return zpl.replaceAll(placeholder, () => rendered);
};
